import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, categoryArr } from "utils/Constants";
import React, { useEffect, useState } from "react";
import Svg, { Path, Rect } from "react-native-svg";
import { TouchableOpacity, View } from "react-native";
import { changeParentSelected, changeSelectedFilter } from "appRedux/reducers/filterSlice";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { useDispatch, useSelector } from "react-redux";

import Accordion from "components/Accordion";
import ListView from "components/ListView";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { memo } from "react";
import { useGlobalSearchParams, useSegments } from "expo-router";

const FilterRecursiveComp = ({
    currentFilters = {},
    categoryID,
    subCategory,
    hasSubCategories = false,
    isFiller = false,
    isNested = false,
    currentFiltersName = "",
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [hasSelectedOptions, setHasSelectedOptions] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    const [childHasSubCategories, setChildHasSubCategories] = useState(true);
    const [ifInParent, setIfInParent] = useState(false);
    const selectedFilters = useSelector((state) => state.FilterReducer.selectedFilters);
    const parentSelected = useSelector((state) => state.FilterReducer.parentSelected);
    const rotate = useSharedValue(180);
    const dispatch = useDispatch();

    const local = useGlobalSearchParams();
    const segments = useSegments();

    const isCategory = segments?.includes('shop') && Object.keys(categoryArr)?.includes(segments?.[1]);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));

    useEffect(() => {
        if (selectedFilters && categoryID) {
            let temp = [];
            if (hasSubCategories) {
                temp = [...(selectedFilters?.[categoryID] || []), ...parentSelected];
            } else {
                temp = [...(selectedFilters?.[categoryID] || [])];
            }
            if (temp && Array.isArray(temp)) {
                let arr = [...temp];
                let ids = arr?.map((o) => o?.id);
                let subCategoryIDs = arr?.map((o) => o?.subCategory);
                if (subCategoryIDs.includes(currentFilters?.id)) {
                    setHasSelectedOptions(true);
                } else {
                    setHasSelectedOptions(false);
                }
                if (ids.includes(currentFilters?.id)) {
                    setIsSelected(true);
                } else {
                    setIsSelected(false);
                }
            } else {
                setIsSelected(false);
                setHasSelectedOptions(false);
            }
        } else {
            setIsSelected(false);
            setHasSelectedOptions(false);
        }
    }, [selectedFilters, categoryID, currentFilters, parentSelected, hasSubCategories]);

    useEffect(() => {
        if (currentFilters?.id == 1) {
            let options = [...currentFilters?.options];
            let tempHasSubCategories = false;
            for (let j = 0; j < options.length; j++) {
                if (Array.isArray(options?.[j]?.options) && options?.[j]?.options?.length > 0) {
                    tempHasSubCategories = true;
                    break;
                }
            }
            setChildHasSubCategories(tempHasSubCategories);
        } else {
            setChildHasSubCategories(false);
        }
    }, [currentFilters]);

    useEffect(() => {
        if (parentSelected) {
            let ifInParent = parentSelected?.find((o) => o?.id == currentFilters?.id);
            if (ifInParent) {
                setIfInParent(true);
            } else {
                setIfInParent(false);
            }
        }
    }, [parentSelected]);

    useEffect(() => {
        if (isCategory && hasSubCategories) {
            setIsOpen((prev) => {
                rotate.value = withTiming(0);
                return true;
            });
        }
    }, [isCategory, hasSubCategories]);

    const onSelect = () => {
        if (hasSubCategories) {
            setIsOpen((prev) => {
                if (prev == true) {
                    rotate.value = withTiming(180);
                    return false;
                } else {
                    rotate.value = withTiming(0);
                    return true;
                }
            });
        } else {
            if (!isSelected) {
                logEvent(analytics, FIREBASE_EVENT_NAMES.FILTER_SELECTED, {
                    [FIREBASE_EVENT_PARAMS.FILTER_NAME]: `${currentFiltersName} - ${currentFilters?.title}`,
                });
            }
            dispatch(
                changeSelectedFilter({
                    categoryID,
                    data: currentFilters,
                    subCategory: subCategory,
                })
            );
        }
    };

    const onParentClicked = () => {
        if (hasSubCategories) {
            if (!isSelected) {
                logEvent(analytics, FIREBASE_EVENT_NAMES.FILTER_SELECTED, {
                    [FIREBASE_EVENT_PARAMS.FILTER_NAME]: `${currentFiltersName} - ${currentFilters?.title}`,
                });
            }
            dispatch(
                changeParentSelected({
                    categoryID: categoryID,
                    id: currentFilters?.id,
                    title: currentFilters?.title,
                    isSubCategory: true,
                })
            );
        }
    };

    if (isFiller) {
        return (
            <TouchableOpacity
                activeOpacity={1}
                style={{
                    marginTop: spV(8),
                    width: "30%",
                    minHeight: hp(52),
                }}
            ></TouchableOpacity>
        );
    }

    if ([1, 6].includes(categoryID)) {
        return (
            <View
                style={{
                    paddingBottom: spV(8),
                    marginTop: isNested ? spV(4) : spV(8),
                    borderBottomWidth: !isNested ? 1 : 0,
                    borderColor: "rgba(33, 36, 39, 0.16)",
                }}
            >
                {((isCategory && !hasSubCategories) || !isCategory) && (
                    <TouchableOpacity
                        onPress={onSelect}
                        activeOpacity={0.8}
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                flex: 1,
                            }}
                        >
                            {hasSubCategories && (
                                <TouchableOpacity onPress={onParentClicked} activeOpacity={0.8}>
                                    {isSelected || ifInParent ? (
                                        <View
                                            style={{
                                                marginRight: spH(8),
                                            }}
                                        >
                                            <Svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <Rect x="2" y="2" width="16" height="16" rx="2" fill="#212427" />
                                                <Path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M13.5228 7.98753L8.51035 13L6 10.2965L7.0234 9.34624L8.5476 10.9877L12.5353 7L13.5228 7.98753Z"
                                                    fill="white"
                                                />
                                            </Svg>
                                        </View>
                                    ) : (
                                        <View
                                            style={{
                                                height: wp(16),
                                                width: wp(16),
                                                borderRadius: 3,
                                                borderWidth: isSelected ? 0 : 1,
                                                borderColor: "#00000029",
                                                marginRight: spH(8),
                                                backgroundColor: "white",
                                            }}
                                        />
                                    )}
                                </TouchableOpacity>
                            )}
                            {!hasSubCategories && (
                                <>
                                    {isSelected ? (
                                        <View
                                            style={{
                                                marginRight: spH(8),
                                            }}
                                        >
                                            <Svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <Rect x="2" y="2" width="16" height="16" rx="2" fill="#212427" />
                                                <Path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M13.5228 7.98753L8.51035 13L6 10.2965L7.0234 9.34624L8.5476 10.9877L12.5353 7L13.5228 7.98753Z"
                                                    fill="white"
                                                />
                                            </Svg>
                                        </View>
                                    ) : (
                                        <View
                                            style={{
                                                height: wp(16),
                                                width: wp(16),
                                                borderRadius: 3,
                                                borderWidth: isSelected ? 0 : 1,
                                                borderColor: "#00000029",
                                                marginRight: spH(8),
                                                backgroundColor: "white",
                                            }}
                                        />
                                    )}
                                </>
                            )}
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flex: 1,
                                }}
                            >
                                <VText
                                    text={currentFilters?.title}
                                    style={{
                                        fontSize: fp(15),
                                        fontWeight: "350",
                                        lineHeight: fp(24),
                                        color: isNested ? "rgba(33, 36, 39, 0.6)" : "black",
                                        flex: 1,
                                        width: "90%",
                                    }}
                                    numberOfLines={3}
                                />
                                {!isNested && (
                                    <Animated.View style={animatedStyles}>
                                        <Svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <Path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M17 13.0255L16.0255 14L11 8.97452L5.97452 14L5 13.0255L11 7.02548L17 13.0255Z"
                                                fill="#212427"
                                                fillOpacity="0.3"
                                            />
                                        </Svg>
                                    </Animated.View>
                                )}
                            </View>
                        </View>
                    </TouchableOpacity>
                )}

                {isCategory && (
                    <View
                        style={{
                            flex: 1,
                        }}
                    >
                        <ListView
                            type={ListView.Type.Flash}
                            showsVerticalScrollIndicator={false}
                            data={[Array.isArray(currentFilters?.options) ? currentFilters?.options : []].flat()}
                            renderItem={({ item, index }) => {
                                return (
                                    <FilterRecursiveComp
                                        categoryID={categoryID}
                                        subCategory={currentFilters?.id}
                                        currentFilters={item}
                                        key={index}
                                        hasSubCategories={childHasSubCategories}
                                        isNested={true}
                                    />
                                );
                            }}
                            maxToRenderPerBatch={10}
                            keyExtractor={(item, index) => `${item?.id?.toString()}_${index}_filter2`}
                            estimatedItemSize={70}
                            scrollEventThrottle={64}
                        />
                    </View>
                )}
                {!isCategory && (
                    <Accordion viewKey="qwerty" isExpanded={isOpen} enterFrom="top">
                        <View
                            style={{
                                flex: 1,
                                paddingLeft: spH(30),
                                minHeight: 100,
                            }}
                        >
                            <ListView
                                type={ListView.Type.Flash}
                                showsVerticalScrollIndicator={false}
                                data={[Array.isArray(currentFilters?.options) ? currentFilters?.options : []].flat()}
                                renderItem={({ item, index }) => {
                                    return (
                                        <FilterRecursiveComp
                                            categoryID={categoryID}
                                            subCategory={currentFilters?.id}
                                            currentFilters={item}
                                            key={index}
                                            hasSubCategories={childHasSubCategories}
                                            isNested={true}
                                        />
                                    );
                                }}
                                maxToRenderPerBatch={10}
                                keyExtractor={(item, index) => `${item?.id?.toString()}_${index}_filter2`}
                                estimatedItemSize={70}
                                scrollEventThrottle={64}
                            />
                        </View>
                    </Accordion>
                )}
            </View>
        );
    }

    if ([2, 3, 5, 7, 8, 9, 10].includes(categoryID)) {
        return (
            <TouchableOpacity
                onPress={onSelect}
                activeOpacity={0.8}
                style={{
                    flexDirection: "row",
                    // alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: spV(14),
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        flexShrink: 1,
                        paddingRight: spH(28),
                        // alignItems: "center",
                    }}
                >
                    {hasSubCategories && (
                        <View
                            style={{
                                height: wp(16),
                                width: wp(16),
                                borderRadius: 100,
                                borderWidth: 1,
                                borderColor: "#00000029",
                                marginRight: spH(16),
                            }}
                        ></View>
                    )}
                    {!hasSubCategories && (
                        <>
                            {isSelected ? (
                                <View
                                    style={{
                                        marginRight: spH(8),
                                    }}
                                >
                                    <Svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Rect x="2" y="2" width="16" height="16" rx="2" fill="#212427" />
                                        <Path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.5228 7.98753L8.51035 13L6 10.2965L7.0234 9.34624L8.5476 10.9877L12.5353 7L13.5228 7.98753Z"
                                            fill="white"
                                        />
                                    </Svg>
                                </View>
                            ) : (
                                <View
                                    style={{
                                        height: wp(16),
                                        width: wp(16),
                                        borderRadius: 3,
                                        borderWidth: isSelected ? 0 : 1,
                                        borderColor: "#00000029",
                                        marginRight: spH(8),
                                        backgroundColor: "white",
                                    }}
                                />
                            )}
                        </>
                    )}
                    {currentFilters?.colorCode && (
                        <View
                            style={{
                                width: wp(16),
                                height: wp(16),
                                backgroundColor: currentFilters?.colorCode,
                                borderRadius: 100,
                                marginRight: spH(8),
                            }}
                        />
                    )}
                    <VText
                        text={currentFilters?.title}
                        style={{
                            fontSize: fp(15),
                            fontWeight: "350",
                            lineHeight: fp(24),
                            color: isNested ? "rgba(33, 36, 39, 0.6)" : "black",
                            flex: 1,
                            width: "90%",
                        }}
                        numberOfLines={3}
                    />
                </View>
            </TouchableOpacity>
        );
    }
};

export default memo(FilterRecursiveComp);
